import React from "react";
import Seo from "@/components/vlyt/Seo";

const SECTIONS = [
  {
    h: "1. Who we are",
    p: "Vlyt Technologies Ltd operates the Vlyt intra-community mobility platform for Covenant University. Our registered contact is hello@govlyt.com.",
  },
  {
    h: "2. Data we collect",
    p: "Matric number, name, email, device passkey identifiers, ride locations, and Royal Rides purchase history. We do not collect SIM-derived phone numbers.",
  },
  {
    h: "3. How we use it",
    p: "To match rides, verify identity, process payments, prevent fraud, and improve service quality. We never sell personal data.",
  },
  {
    h: "4. Zero-leakage principle",
    p: "Fare information stays between rider and driver. Vlyt only settles the trust layer and records event metadata for safety and support.",
  },
  {
    h: "5. Your rights",
    p: "You may request access, correction, export, or deletion of your data by emailing privacy@govlyt.com. We respond within 14 days.",
  },
  {
    h: "6. Retention",
    p: "Active accounts are retained for the duration of your Vlyt membership. On deletion, personal identifiers are purged within 30 days.",
  },
  {
    h: "7. Contact",
    p: "Questions? Email hello@govlyt.com or write to Vlyt Technologies Ltd, Port Harcourt, Rivers State, Nigeria.",
  },
];

export default function Privacy() {
  return (
    <>
      <Seo title="Privacy Policy · Vlyt" canonical="https://govlyt.com/privacy" />
      <section className="pt-[120px] pb-24 mx-auto max-w-[880px] px-5 md:px-10">
        <div className="text-eyebrow mb-4">Legal</div>
        <h1 className="text-h1 font-display">Privacy Policy</h1>
        <p className="mt-3 text-[color:var(--vlyt-muted)] font-mono text-[13px]">
          Effective at platform launch · Last updated on this build
        </p>

        <div className="mt-12 space-y-10">
          {SECTIONS.map((s) => (
            <div key={s.h}>
              <h2 className="text-h3 font-display text-[color:var(--vlyt-text)]">{s.h}</h2>
              <p className="mt-3 text-[color:var(--vlyt-muted)] text-[15px] leading-relaxed">{s.p}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
